import { Challenge } from '@/types';

export function getCompletedChallenges(challenges: Challenge[]): Challenge[] {
  return challenges.filter(c => c.status === 'completed');
}

export function getChallengeRewards(challenge: Challenge) {
  return {
    points: challenge.reward.points,
    petItems: challenge.reward.petItems || [],
    badges: challenge.reward.badges || [],
    title: challenge.reward.title
  };
}